
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

interface TextSectionProps {
  title: string;
  content: string;
  icon: React.ReactNode;
  className?: string;
}

export const TextSection: React.FC<TextSectionProps> = ({ title, content, icon, className }) => {
  // Don't render if no content
  if (!content || content.trim().length === 0) {
    return null;
  }

  // Clean up the content to remove duplicate headers and format properly
  const cleanedContent = content
    .replace(/^#+\s*.*$/gm, '') // Remove markdown headers
    .replace(/\n{3,}/g, '\n\n')  // Remove excess newlines
    .trim();

  if (!cleanedContent) return null;

  return (
    <Card className={`border-heaven-gold/10 mb-6 ${className || ''}`}>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-heaven-gold text-lg font-medium">
          {icon}
          <span>{title}</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-gray-800 prose max-w-none">
          {cleanedContent.split('\n\n').map((paragraph, index) => (
            <p key={index} className="mb-4 last:mb-0 leading-relaxed">
              {paragraph.trim()}
            </p>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
